import { useEffect } from "react";

export default function PendingMercadoPago() {
  useEffect(() => {
    (window as any).ReactNativeWebView.postMessage('com.maxdreamapp://url_mp_pending');
  }, [])
  return <h1>Redirigiendo...</h1>
}
